import { FormSelectA11y, FormSelectA11yProps, Option } from '@glow/ui-components'
import { FieldValidator, useField } from 'formik'
import { useMemo } from 'react'
import { useFormikError } from '../formik-error'

export interface FormikSelectA11yProps extends Omit<FormSelectA11yProps, 'onChange' | 'onSelect' | 'selected'> {
  name: string
  options: Option[]
  validate?: FieldValidator
  onChange?: (value?: string | number) => void
}

export const FormikSelectA11y = ({
  name,
  options,
  onChange,
  validate,
  error: outerError,
  errorMessage: outerErrorMessage,
  ...props
}: FormikSelectA11yProps) => {
  const [field] = useField({ name, validate })
  const formikError = useFormikError(name, validate)
  const error = Boolean(formikError) || Boolean(outerError)
  const errorMessage = formikError?.message || outerErrorMessage

  const handleChange = (selectedCode?: string | number) => {
    onChange?.(selectedCode)
    field.onChange({ target: { value: selectedCode, name } })
  }

  const selected = useMemo(() => options.find((option) => option.code == field.value)?.code, [field.value, options])

  return (
    <FormSelectA11y
      {...field}
      error={error}
      errorMessage={errorMessage}
      {...props}
      selected={selected}
      options={options}
      onSelect={handleChange}
    />
  )
}
